import type phaser from 'phaser'
// see: https://gamedevacademy.org/creating-a-preloading-screen-in-phaser-3/
function getGameBounds(sc: phaser.Scene) {
  let scale = sc.sys.game.scale
  return { width: scale.width, height: scale.height }
}

export function preload(sc: phaser.Scene) {
  let progressBar = sc.add.graphics()
  // let progressBox = sc.add.graphics()

  const offwhite = 0xf2deab
  const offwhiteDull = 0xc2b289
  const offwhiteBorder = 0x6a583e

  let gb = getGameBounds(sc)
  let w = gb.width * 0.5
  let h = gb.height * 0.2
  let x = gb.width / 2 - w / 2
  let y = gb.height / 2 - h / 2
  let b = h * 0.1
  // let width = sc.cameras.main.width
  // let height = sc.cameras.main.height
  let loadingText = sc.make.text({
    x: gb.width / 2,
    y: gb.height / 2 - 5 - h / 2 - h * 0.15,
    text: 'Loading...',
    style: {
      font: '80px monospace',
      //fill: '#ffffff',
    },
  })
  loadingText.setOrigin(0.5, 0.5)

  let percentText = sc.make.text({
    x: gb.width / 2,
    y: gb.height / 2 + h / 2 + h * 0.15,
    text: '0%',
    style: {
      font: '80px monospace',
      // fill: '#ffffff',
    },
  })
  percentText.setOrigin(0.5, 0.5)

  const setProgress = (val: number) => {
    percentText.setText(Math.floor(val * 100) + '%')

    progressBar.clear()
    progressBar.fillStyle(offwhiteBorder, 0.8)
    progressBar.fillRect(x, y, w, h)

    progressBar.fillStyle(offwhite, 1)
    progressBar.fillRect(x + b, y + b, (w - b * 2) * val, h - b * 2)
  }
  setProgress(0)
  sc.load.on('progress', (value: number) => {
    setProgress(value)
  })

  // let assetText = sc.make.text({
  //   x: width / 2,
  //   y: height / 2 + 50,
  //   text: '',
  //   style: {
  //     font: '18px monospace',
  //     // fill: '#ffffff',
  //   },
  // })

  // assetText.setOrigin(0.5, 0.5)

  // sc.load.on('fileprogress', (file: any) => {
  //   assetText.setText('Loading asset: ' + file.key)
  // })

  sc.load.on('complete', function () {
    progressBar.destroy()
    // progressBox.destroy()
    loadingText.destroy()
    percentText.destroy()
    // assetText.destroy()
  })

  // this.load.image('logo', 'zenvalogo.png');
  // for (var i = 0; i < 5000; i++) {
  //     this.load.image('logo'+i, 'zenvalogo.png');
  // }
}
